export const LOAD_ORDERS_LIST = 'LOAD_ORDERS_LIST';
export const EDIT_ORDER = 'EDIT_ORDER';
export const FINISH_ORDER = 'FINISH_ORDER';
export const RESET_ORDERS = 'RESET_ORDERS';
export const LOAD_ADS_LIST = 'LOAD_ADS_LIST';
export const LOAD_DEALS_LIST = 'LOAD_DEALS_LIST';
export const ADD_AD = 'ADD_AD';
export const OPEN_CLAIM = 'OPEN_CLAIM';
export const CANCEL_CLAIM = 'CANCEL_CLAIM';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const SWITCH_NOTE = 'SWITCH_NOTE';
export const ADD_ORDER_COMMENT = 'ADD_ORDER_COMMENT';
export const DELETE_ORDER_COMMENT = 'DELETE_ORDER_COMMENT';
export const RESTART_FINISH_ERROR_ORDERS = 'RESTART_FINISH_ERROR_ORDERS';
